// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"94665810","860":"27f96ffb"}[chunkId] + ".js";
};